// extracted by css-extract-rspack-plugin
export default {"root":"Gop305","variant-subscriptions":"UzEPRV","variantSubscriptions":"UzEPRV","variant-adoptables":"x1_4Hr","variantAdoptables":"x1_4Hr"};